

export default function BoletoInfracao({ base64 }) {
    return (
        <div
            className={`break bg-white shadowFicha mainContainerFicha p-4`}
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <img
                src={`data:image/png;base64,${base64}`}
                alt="Boleto"
                style={{
                    width: "750px",
                    height: "auto",
                    objectFit: "contain",
                }}
            />
        </div>
    );
}
